import ScrollReveal from "@/components/ScrollReveal";

// PwC "We bring the right technology" / "Why us" block.
// Top: small kicker + huge serif heading
// Bottom: left image, right list of paragraphs separated by orange dashes.
export default function WhyUsBlock({ kicker, title, image, points = [] }) {
  return (
    <section className="bg-white py-20 md:py-28" data-testid="why-us-block">
      <div className="max-w-[1480px] mx-auto px-6 lg:px-10">
        <ScrollReveal>
          <div className="text-[14px] text-[var(--abs-ink)] mb-5">{kicker}</div>
          <h2 className="serif text-5xl md:text-6xl lg:text-[88px] leading-[1.02] tracking-tight max-w-4xl mb-16 lg:mb-24">
            {title}
          </h2>
        </ScrollReveal>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <ScrollReveal className="lg:col-span-6">
            <div className="img-frame aspect-square bg-[var(--abs-soft)]">
              <img src={image} alt={title} className="w-full h-full object-cover" />
            </div>
          </ScrollReveal>
          <ScrollReveal delay={100} className="lg:col-span-6">
            <ul className="space-y-10">
              {points.map((p, i) => (
                <li key={i}>
                  <span className="block w-7 h-[3px] bg-[var(--abs-orange)] mb-5" aria-hidden />
                  <p className="text-[16.5px] leading-[1.75] text-[var(--abs-ink)] max-w-lg">{p}</p>
                </li>
              ))}
            </ul>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
